import { createSceneReducer } from '../../reducers-util';
import invoicesDataReducer from './invoices.data';
import invoicesUiReducer from './invoices.ui';

export default createSceneReducer(invoicesDataReducer, invoicesUiReducer);
